module.exports = __webpack_public_path__ + "img/apple-touch-icon.2d20f0ce.png";